import { render, staticRenderFns } from "./BlogList.vue?vue&type=template&id=136a013a&scoped=true&"
import script from "./BlogList.vue?vue&type=script&lang=js&"
export * from "./BlogList.vue?vue&type=script&lang=js&"
import style0 from "./BlogList.vue?vue&type=style&index=0&id=136a013a&prod&lang=scss&scoped=true&"
import style1 from "./BlogList.vue?vue&type=style&index=1&id=136a013a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136a013a",
  null
  
)

export default component.exports